
















































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
// store
import moduleStore from './store/VipWechatPay'
// component
import { Toast, Dialog } from 'vant'
// 支付
import LZString from '../../utils/lz-string.min'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class ycdWechatPay extends Vue {
  // 图片资源
  support = require('/public/images/member/icon_support.svg')
  not_support = require('/public/images/member/icon_not_support.svg')
  
  // 支付接口参数
  submitParams = {
    phone: '',
    // 当前选择的套餐
    packageId: null
  }

  mounted() {
    // 获取套餐列表
    this.getVipPackageList()
    // 获取权益列表
    this.getVipRightsList()
  }

  /****************************** 切换购买套餐类型 ******************************/

  packageTabList = [
    {
      code: 'VIP',
      name: '超级会员',
      icon: ''
    }, {
      code: 'TRAFFIC',
      name: '流量包',
      icon: ''
    }
  ]

  // 当前切换到的购买套餐的类型
  activePackageTab = 'VIP'

  /** 切换 */
  handlePackageTabChange(code: string) {
    if (this.activePackageTab === code) return
    this.activePackageTab = code
    // 获取套餐列表
    this.getVipPackageList()
  }

  /****************************** 流量包套餐切换 ******************************/

  trafficTabList = [
    {
      code: 'COMPOSE',
      name: '作品生成'
    }, {
      code: 'BACKGROUND',
      name: '背景提取时长'
    }
  ]

  // 'COMPOSE': 合成视频流量包; 'BACKGROUND': 背景音乐提取流量包;
  activeTrafficTab = 'COMPOSE'

  /** 切换流量包套餐（ 合成视频流量包 || 背景音乐提取流量包 ） */
  handleTrafficTabChange(code: string) {
    if (this.activeTrafficTab === code) return
    this.activeTrafficTab = code
    // 获取套餐列表
    this.getVipPackageList()
  }

  /****************************** 套餐列表 ******************************/

  // 套餐列表
  packageList = []

  /** 获取套餐列表 */
  getVipPackageList() {
    const params = {}
    if (this.activePackageTab === 'VIP') {
      params['type'] = 1
    }
    if (this.activePackageTab === 'TRAFFIC' && this.activeTrafficTab === 'COMPOSE') {
      params['type'] = 2
    }
    if (this.activePackageTab === 'TRAFFIC' && this.activeTrafficTab === 'BACKGROUND') {
      params['type'] = 3
    }
    this.$http('getYcdPackageListApi', params)
      .then(res => {
        const { code, data } = res
        if (code === 200) {
          this.packageList = data
          if (this.packageList && this.packageList.length) {
            this.handlePackageChange(this.packageList[0].packageId)
          }
        }
      })
  }

  // 当前切换到的套餐详情
  get activePackageItem(): any {
    let packageItem = {}
    this.packageList.forEach(item => {
      if (item.packageId === this.submitParams.packageId) {
        packageItem = item
      }
    })
    return packageItem
  }

  /** 套餐切换 */
  handlePackageChange(id: number | null) {
    if (this.submitParams.packageId === id) return
    this.submitParams.packageId = id
  }

  /****************************** 提交支付订单 ******************************/

  /** 校验手机号对应的会员信息 */
  checkUserVipType(phone: string, callback) {
    const { success, failed } = callback
    this.$http('getPhoneVipType', { phone: phone })
      .then(res => {
        const { code, data } = res
        if (code === 200) {
          if (data.isVip && data.vipType === 1) {
            success()
            return
          }
        }
        failed()
      })
      .catch(() => {
        failed()
      })
  }

  /** 点击立即支付按钮 */
  handleClickPay() {
    const phoneReg = /^1[3456789]\d{9}$/
    if (!phoneReg.test(this.submitParams.phone)) {
      Toast({
        message: '请输入正确的手机号',
        icon: "none",
        duration: 1000
      })
      return
    }
    Dialog.confirm({
      title: `请确认手机号: ${ this.submitParams.phone }`,
      message: "支付后不支持更换手机号、退款，请确认后再购买",
      confirmButtonText: "确认购买",
      cancelButtonText: "修改手机号",
      className: "confirm-dialog ycd-confirm-dialog",
    })
      .then(() => {
        Toast.loading({
          message: '加载中...',
          forbidClick: true
        })
        if (this.activePackageTab === 'TRAFFIC') {
          this.checkUserVipType(this.submitParams.phone, {
            success: () => {
              this.handleCreateOrder()
            },
            failed: () => {
              Toast({
                message: '该手机号对应的账号不是超级会员，仅超级会员可购买流量包',
                icon: "none",
                duration: 3000
              })
            }
          })
        } else {
          this.handleCreateOrder()
        }
      })
  }

  handleCreateOrder() {
    const params = {
      // 元创岛 h5 支付
      payMethod: 'wechat_h5',
      // 来源
      source: 'yuanchuangdao',
      // 设备
      device: 'H5_IOS',
      // 微信的登录验证字段
      jsCode: '',
      // 用户绑定权益的手机号
      phone: this.submitParams.phone,
      // 购买的会员套餐
      packageId: this.submitParams.packageId,
      // 暂时不用的字段
      channelCode: '',
    }
    switch(this.activePackageTab) {
      case 'VIP':
        params['type'] = this.activePackageTab
        break;
      case 'TRAFFIC':
        params['type'] = this.activeTrafficTab
        break;
    }
    this.$http('createYcdOrderApi', params)
      .then(res => {
        const { code, data } = res
        if (code === 200) {
          const payParams = data.ext || {}
          this.handleWechatPay({
            ...payParams,
            orderId: data.orderId || ''
          })
        } else {
          Toast.clear()
        }
      })
      .catch(() => {
        Toast.clear()
      })
  }

  handleWechatPay(params) {
    // 跳转到支付中间页
    const infoCompress = LZString.compressToBase64(JSON.stringify({
      ...params
    }))
    this.$router.push({
      path: '/ycd-payment-middle',
      query: {
        info: infoCompress,
        payType: 'wxpayH5',
        from: 'ycdPayment',
        phone: this.submitParams.phone,
        package: this.activePackageItem.packageName || ''
      }
    })
  }

  /****************************** 超级会员权益列表 ******************************/
  
  vipRightsList = []

  getVipRightsList() {
    this.$http('getYcdVipRightsListApi')
      .then((res) => {
        const { code, data } = res
        if (code === 200) {
          this.vipRightsList = data
        }
      })
  }

  /****************************** 隐私条款跳转 ******************************/

  toProtocol(link: string) {
    switch(link) {
      case 'protocol':
        window.open('https://bh.moyin.com/#/protocol')
        break;
      case 'privacy':
        window.open('https://bh.moyin.com/#/privacy')
        break;
    }
  }

}
